import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'src/store';
import { createQueryParams, readQueryParams } from 'src/utils/QueryParamsHelper';
import AvailabilityHistoryFilters from './AvailabilityHistoryFilters';
import { IAgentPerformanceParams } from '../../constants/types';
import { AGENT_PERFORMANCE, DEFAULT_PAGE_NO, DEFAULT_PAGE_SIZE, ViewType } from '../../constants';
import { useEffect } from 'react';
import { isAllowedToView, redirectToAllCases, setViewType } from '../../utlis';
import BackIcon from '@cp/src/assets/images/icons/BackIcon';
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import APP_ROUTES from '@cp/src/layout/Routes';
import styles from './index.module.scss';
import HistoryMainContent from './MainContent';
import Loader from 'src/components/Loader/Loader';
import { getAvailabilityHistoryData, fetchAgentAvailabilityLists } from '../../actions';
import { getFormattedDateSubtractedByDays } from '@cp/src/utils/DateHelper';

const AvailabilityHistory = () => {
  const userData = useSelector((state: RootState) => state.common.userData);
  const historyLoading = useSelector(
    (state: RootState) => state.agentAvailabilitySlice.historyLoading
  );
  const { [AGENT_PERFORMANCE]: params } = readQueryParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toAgentAvailability = APP_ROUTES.AGENT_AVAILABILITY.path;
  const updateAndNavigate = (updatedParams: IAgentPerformanceParams) => {
    const url = createQueryParams({
      [AGENT_PERFORMANCE]: updatedParams
    });
    navigate(url);
  };
  const setInitialQueryParams = (params: IAgentPerformanceParams) => {
    const queryParams: IAgentPerformanceParams = { ...params };
    queryParams['viewType'] = setViewType(userData);

    if (!queryParams.pageNo) {
      queryParams['pageNo'] = DEFAULT_PAGE_NO;
    }
    if (!queryParams.pageSize) {
      queryParams['pageSize'] = DEFAULT_PAGE_SIZE;
    }
    if (!queryParams.radioOption) {
      queryParams['radioOption'] = 'All';
    }
    updateAndNavigate(queryParams);
  };
  const urlParams = readQueryParams();
  const startDate = params?.startDate || getFormattedDateSubtractedByDays(7);
  useEffect(() => {
    if (!isAllowedToView(userData)) {
      redirectToAllCases(navigate);
    }

    dispatch(fetchAgentAvailabilityLists());
    const referenceId =
      params?.viewType === ViewType.SENIOR_TEAM_LEAD && params?.teamLeadId
        ? params.teamLeadId
        : userData?.referenceId || '';

    dispatch(getAvailabilityHistoryData(startDate, referenceId));
    setInitialQueryParams(params);
  }, [params?.teamLeadId, params?.viewType, userData?.referenceId]);
  const handleBackNavigation = () => {
    const backParams = {
      viewType: params?.viewType,
      teamLeadId: params?.teamLeadId,
      agentId: params?.agentId,
      pageNo: '1',
      pageSize: '50'
    };
    const url = createQueryParams({
      [AGENT_PERFORMANCE]: backParams
    });
    navigate(`${toAgentAvailability}${url}`);
  };
  return (
    <div className="px-[32px] py-[24px]">
      <div className="flex flex-row justify-start gap-[16px] items-center pb-[24px]">
        <div className="cursor-pointer" onClick={handleBackNavigation}>
          <BackIcon size={'16'} />
        </div>
        <Typography variant="h2" className="text-grayscale-1">
          Agents Availability History
        </Typography>
      </div>
      <div className={styles.filtersContainer}>
        <AvailabilityHistoryFilters params={params} updateAndNavigate={updateAndNavigate} />
      </div>
      <HistoryMainContent urlParams={params} updateAndNavigate={updateAndNavigate} />
      <Loader show={historyLoading} className={styles.loadingState} animate={false} />
    </div>
  );
};

export default AvailabilityHistory;
